import React from "react";
import { Button,Card, Image } from 'react-bootstrap';
import './Books.css';
import { Link } from "react-router-dom";

const Books = (props) => {
  console.log(props);

  const{name,_id,imageUrl,price,author} = props.book;



  return (
    <div className="container">
    
      <Card className="main-card">
        <Card.Img className="card-img" variant="top" src={imageUrl} />
        <Card.Body>
          <Card.Title><Link to = {"/bookDetails/" + _id} >{name}</Link> </Card.Title>
           <p>{author}</p>
           <p>{_id}</p>
           <div className="card-row">
           <div  className="col-helf">
               <h3>${price}</h3>
          </div>
          <div className="col-helf">

          <Link to={`/checkout/${_id}`}>

         
          <Button variant="success">Buy Now</Button>
            
          </Link>
               

               {/* onClick={ () => props.handleAddBook(props.book)} */}
          </div>

           </div>
           
        </Card.Body>
      </Card>

     
    </div>
  );
};

export default Books;
